import * as React from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'next-i18next';

import { Badge } from '@restworld/ui-ds-base';

import { restaurantDetailsAtom, ShowcaseSectionTitle } from '.';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IVenueRolesProps {}

const VenueRoles: React.FC<IVenueRolesProps> = () => {
  const restaurantDetails = useAtomValue(restaurantDetailsAtom);
  const { t } = useTranslation('restaurant-showcase-v2');

  const occupationTemplates = React.useMemo(
    () => restaurantDetails?.occupationTemplates ?? [],
    [restaurantDetails?.occupationTemplates]
  );
  const averageHiresPerYear = restaurantDetails?.averageHiresPerYear;
  const occupationTemplatesList = React.useMemo(
    () =>
      occupationTemplates?.length > 0 && (
        <div className="self-stretch inline-flex justify-start items-start gap-4 flex-wrap content-start">
          {occupationTemplates.map((occupationTemplate: string) => (
            <Badge key={occupationTemplate} variant="tertiary" className="rounded">
              {occupationTemplate}
            </Badge>
          ))}
        </div>
      ),
    [occupationTemplates]
  );

  if (occupationTemplates.length === 0 && !averageHiresPerYear) return null;

  return (
    <div className="self-stretch inline-flex flex-col justify-start items-start gap-4">
      <ShowcaseSectionTitle title={t('frequently_sought_roles')} />
      <div className="self-stretch p-4 bg-purple-50 rounded-lg flex flex-col justify-start items-start gap-4">
        {occupationTemplatesList}
        {averageHiresPerYear && (
          <h5 className="self-stretch justify-start text-purple-700 text-sm font-normal">
            {t(averageHiresPerYear)} {t('people_hired_on_average_each_year')}
          </h5>
        )}
      </div>
    </div>
  );
};

export default VenueRoles;
